import { routes as raiseRoutes } from "./raise/routes";
import { routes as batchingRoutes } from "./batching/routes";
import { routes as batchesRoutes } from "./batches/routes";
import { routes as orgReceiptRoutes } from "./org-receipt/routes";
import { routes as orgReportRoutes } from "./statement/routes";
export const routes = (prefix = `claims`) => [
    {
        path: `/${prefix}`,
        name: `${prefix}.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.index`,
                PageDescription: "Claims Dashboard",
            },
        },
    },
    ...raiseRoutes(prefix),
    ...batchingRoutes(prefix),
    ...batchesRoutes(prefix),
    ...orgReceiptRoutes(prefix),
    ...orgReportRoutes(prefix),
];
